import SnsButton from "@/components/core/Button/SnsButton";
import { InputField } from "@/components/shared/fields/InputField/InputField";
import { PasswordField } from "@/components/shared/fields/PasswordField/PasswordField";
// import { useSession } from '@/hooks/use-session';
// import { ILoginData, login } from '@/mutations/auth';
// import { getErrors } from '@/utils/form-error';
import { BoxProps, Button, Checkbox, HStack, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import {} from "react-router-dom";

export interface ILoginFormValues {
  email: string;
  password: string;
}

export const LoginForm: FC<BoxProps> = props => {
  const { t } = useTranslation("login-form");
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError
  } = useForm<ILoginFormValues>();
  // const { mutate } = useSession();
  // const client = useClient();
  const navigate = useNavigate();
  const location = useLocation();
  async function onSubmit(formData: ILoginFormValues) {
    // try {
    // 	const data: ILoginData = {
    // 		type: 'sessions',
    // 		attributes: formData,
    // 	};
    // 	await mutate(() => login(client, { data }), false);
    // } catch (errors) {
    // 	if (errors instanceof Response) {
    // 		getErrors(errors.error).forEach(({ name, type, message = t('error') }) => {
    // 			if (name === 'email' || name === 'password') {
    // 				setError(name, { type, message });
    // 			}
    // 		});
    // 	}
    // }
  }

  const handleSNSLogin = (provider: string) => {
    // navigate(`${process.env.REACT_APP_API_URL}/oauth/${provider}`, {
    //   replace: true,
    //   state: {
    //     host: window.location.href
    //   }
    // });
    window.location.href = `${process.env.REACT_APP_API_URL}/oauth/${provider}?host=${encodeURIComponent(window.location.href)}`;
  };

  return (
    <Stack
      as="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
      spacing="6"
      {...props}
    >
      <Stack spacing="5">
        <InputField
          label={t("Email")}
          errors={errors}
          id="email"
          type="email"
          {...register("email", { required: t("required") })}
        />
        <PasswordField
          label={t("Password")}
          errors={errors}
          id="password"
          {...register("password", { required: t("required") })}
        />
      </Stack>
      {/* <HStack justify="space-between">
        <Checkbox color="black" colorScheme="red" defaultChecked>
          Remember me
        </Checkbox>
        <Button colorScheme="red" size="sm" variant="link">
          Forgot password?
        </Button>
      </HStack> */}

      <Stack spacing="6">
        <Button colorScheme="red" type="submit">
          {t("login")}
        </Button>
        <HStack spacing="6" justify="center">
          <SnsButton
            img="/svg/sns/google.svg"
            onClick={() => handleSNSLogin("google")}
          />

          <SnsButton
            img="/svg/sns/linked-in.svg"
            onClick={() => handleSNSLogin("linkedin")}
          />
        </HStack>
      </Stack>
    </Stack>
  );
};
